import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AdminSSS } from "./type";

const AdminSSSDetailPage = forwardRef<any, { data: AdminSSS }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Question"}
                label={{
                    text: localize.getString("question"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Answer"}
                label={{
                    text: localize.getString("answer"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default AdminSSSDetailPage